import React, { Fragment, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { Helmet } from 'react-helmet'

import Banner from '../components/banner'
import Hero9 from '../components/hero9'
import Pricing from '../components/pricing'
import Trainers from '../components/Trainers'
import Hero91 from '../components/hero91'
import FAQ14 from '../components/faq14'
import Team from '../components/team'
import Gallery from '../components/gallery'
import Contact from '../components/contact'
import MatterportViewer from '../components/MatterportViewer'
import CookieConsent from '../components/CookieConsent'
import { loadSeznamRetargeting } from '../utils/seznamRetargeting'
import './home.css'

const Home = (props) => {
  useEffect(() => {
    let lastScrollY = window.scrollY;
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const navbar = document.querySelector('.home-navbar-interactive');
          const currentScrollY = window.scrollY;

          if (navbar) {
            // Přidá/odebere 'scrolled' třídu pro vizuální změny
            if (currentScrollY > 50) {
              navbar.classList.add('scrolled');
            } else {
              navbar.classList.remove('scrolled');
            }

            // Na mobilních zařízeních: skryje při scrollu dolů, ukáže při scrollu nahoru
            if (window.innerWidth <= 767) {
              if (currentScrollY > lastScrollY && currentScrollY > 100) {
                // Scrolluje dolů - skryj navigaci
                navbar.classList.add('hide-nav');
              } else {
                // Scrolluje nahoru - ukaž navigaci
                navbar.classList.remove('hide-nav');
              }
            }
          }

          lastScrollY = currentScrollY;
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogoClick = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const [cookieBannerKey, setCookieBannerKey] = useState(0);

  // Handler pro cookie consent
  const handleCookieConsent = (hasConsent) => {
    console.log('Cookie consent:', hasConsent ? 'Souhlasím' : 'Odmítnuto');

    // Načtení Seznam.cz retargeting scriptu s příslušným consent
    loadSeznamRetargeting(hasConsent, null);
  };

  const handleOpenCookieSettings = () => {
    localStorage.removeItem('cookieConsent');
    localStorage.removeItem('cookieConsentDate');
    setCookieBannerKey(k => k + 1);
  };

  return (
    <div className="home-container">
      <Helmet>
  <title>Fit Elite Česká Lípa | Mnohem více než jen moderní posilovna </title>
  <meta
    name="description"
    content="Fit Elite Česká Lípa a FitElite.cz – moderní posilovna, skupinové tréninky a profi trenéři. Přijďte si zacvičit a posuňte svou kondici dál!"
  />
  <meta
    property="og:title"
    content="Fit Elite Česká Lípa | FitElite.cz - Moderní Posilovna"
  />
  <meta
    property="og:description"
    content="Fit Elite – špičkově vybavená posilovna v České Lípě. Skupinové tréninky, osobní koučink i skvělá atmosféra. FitElite.cz - přijďte si dát do těla!"
  />
  {/* Přidáme další meta tagy pro lepší SEO */}
  <meta name="keywords" content="Fit Elite, posilovna Česká Lípa, fitness centrum Česká Lípa, gym Česká Lípa, cvičení Česká Lípa, osobní trenér Česká Lípa, skupinové lekce, fitness, posilovací stroje, Matrix, Vision" />
  <link rel="canonical" href="https://fitelite.cz" />
  
  {/* Structured Data pro lepší indexaci */}
  {/* Structured Data pro lepší indexaci */}
  <script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org",
    "@type": "SportsActivityLocation",
    "additionalType": "https://schema.org/GymOrFitnessCenter",
    "name": "Fit Elite Česká Lípa - Moderní posilovna a fitness centrum",
    "alternateName": [
      "FitElite.cz", 
      "FitElite Gym", 
      "FitElite Fitness", 
      "FitElite.cz", 
      "Fit Elite Gym", 
      "Fit Elite Fitness", 
      "Posilovna Česká Lípa", 
      "Fitness centrum Česká Lípa",
      "Gym Česká Lípa",
      "Cvičení Česká Lípa",
      "Posilovna FitElite",
      "Posilovna Fit Elite"
        ],
    "url": "https://fitelite.cz",
    "description": "Fit Elite je moderní posilovna a fitness centrum v České Lípě s profesionálními trenéry, špičkovým vybavením značek Matrix a Vision a přátelskou atmosférou. Hledáte kvalitní cvičení v České Lípě? Navštivte náš gym!",
    "slogan": "Fit Elite - Nejlepší posilovna a fitness centrum v České Lípě",
    "telephone": "+420777123123",
    "email": "info@fitelite.cz",
    "openingHours": ["Mo-Fr 06:00-22:00", "Sa-Su 07:00-21:00"],
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Erbenova 2906",
      "addressLocality": "Česká Lípa",
      "postalCode": "470 01",
      "addressCountry": "CZ"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 50.6834,
      "longitude": 14.5327
    },
    "keywords": "posilovna Česká Lípa, fitness centrum Česká Lípa, gym Česká Lípa, cvičení Česká Lípa, posilovna, fitness, trénink Česká Lípa, sportovní centrum Česká Lípa",
    "amenityFeature": [
      {
        "@type": "LocationFeatureSpecification",
        "name": "Posilovací stroje Matrix a Vision",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "Kardio zóna pro cvičení",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "Diagnostická váha Tanita",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "Plně klimatizovaná posilovna",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "Chill zone pro odpočinek",
        "value": true
      },
      {
        "@type": "LocationFeatureSpecification",
        "name": "Osobní trenéři a cvičitelé",
        "value": true
      }
    ],
    "makesOffer": [
      {
        "@type": "Offer",
        "name": "Jednorázové vstupy do posilovny",
        "description": "Jednorázové vstupy do fitness centra Fit Elite v České Lípě"
      },
      { 
        "@type": "Offer",
        "name": "Měsíční permanentky do fitness centra",
        "description": "Zvýhodněné měsíční vstupy do posilovny Fit Elite"
      },
      {
        "@type": "Offer",
        "name": "Studentská sleva",
        "description": "Zvýhodněná cena pro studenty v posilovně Česká Lípa"
      }
    ],
    "image": [
      "https://fitelite.cz/thumbnail_logo%20fit%20kratke%20z-1500w.webp"
    ],
    "priceRange": "$$",
    "potentialAction": {
      "@type": "ReserveAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://rezervace.fitelite.cz"
      },
      "result": {
        "@type": "Reservation",
        "name": "Rezervace do fitness centra Fit Elite Česká Lípa"
      }
    },
    "sameAs": [
      "https://www.instagram.com/fitelite.cz"
    ]
  })}
</script>
</Helmet>
      <header data-thq="thq-navbar" className="home-navbar-interactive">
        <Link to="/" className="home-navlink1" onClick={handleLogoClick}>
          <img
            alt="Fitness Website Logo"
            src="/thumbnail_logo%20fit%20kratke%20z-200h.webp"
            className="home-image11"
          />
        </Link>
        <div data-thq="thq-navbar-nav" className="home-desktop-menu">
          <nav className="home-links1">
            <a href="#9" className="home-link10">
              <span className="home-link11 ArialBlack button-clean button">
                Koncept
              </span>
            </a>
            <a href="#pricing" className="home-link12">
              <span className="home-link21 ArialBlack button-clean button">
                Ceník
              </span>
            </a>
            <a href="#Hero91" className="home-link14">
              <span className="home-link31 ArialBlack button-clean button">
                Otevírací doba
              </span>
            </a>
            <a href="#FAQ14" className="home-link15">
              <span className="home-link41">FAQ</span>
            </a>
            <button type="button">
              <a
                href="#team"
                className="home-link51 ArialBlack button-clean button"
              >
                Náš tým
              </a>
            </button>
              <a href="#trainers" className="home-link13">
              <span className="home-link31 ArialBlack button-clean button">
                Trenéři
              </span>
            </a>
            <a href="#gallery" className="home-link16">
              <span className="home-link61 ArialBlack button-clean button">
                Galerie
              </span>
            </a>
            <a href="#Contact" className="home-link17">
              <span className="home-link71 ArialBlack button-clean button">
                Kontakty
              </span>
            </a>
          </nav>
          <button
            type="button"
            className="home-button2 thq-button-filled button"
          >
            <a
              href="https://rezervace.fitelite.cz"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link18 thq-body-large"
            >
              Přihlášení a rezervace
            </a>
          </button>
          <div className="home-icon-group1">
            <a
              href="https://www.instagram.com/fitelite.cz/"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link19"
            >
              <svg
                viewBox="0 0 877.7142857142857 1024"
                className="home-icon10 thq-icon-x-small"
              >
                <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
              </svg>
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61574459933009"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link20"
            >
              <svg
                viewBox="0 0 602.2582857142856 1024"
                className="home-icon12 thq-icon-x-small"
              >
                <path d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"></path>
              </svg>
            </a>
            <a
              href="https://www.youtube.com/@Fitelite_cl"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link22"
            >
              <svg
                viewBox="0 0 1024 1024"
                className="home-icon14 thq-icon-x-small"
              >
                <path d="M406.286 644.571l276.571-142.857-276.571-144.571v287.429zM512 152c215.429 0 358.286 10.286 358.286 10.286 20 2.286 64 2.286 102.857 43.429 0 0 31.429 30.857 40.571 101.714 10.857 82.857 10.286 165.714 10.286 165.714v77.714s0.571 82.857-10.286 165.714c-9.143 70.286-40.571 101.714-40.571 101.714-38.857 40.571-82.857 40.571-102.857 42.857 0 0-142.857 10.857-358.286 10.857v0c-266.286-2.286-348-10.286-348-10.286-22.857-4-74.286-2.857-113.143-43.429 0 0-31.429-31.429-40.571-101.714-10.857-82.857-10.286-165.714-10.286-165.714v-77.714s-0.571-82.857 10.286-165.714c9.143-70.857 40.571-101.714 40.571-101.714 38.857-41.143 82.857-41.143 102.857-43.429 0 0 142.857-10.286 358.286-10.286v0z"></path>
              </svg>
            </a>
          </div>
        </div>
        <div data-thq="thq-burger-menu" className="home-burger-menu">
          <div className="home-icon-group2">
            <a
              href="https://www.instagram.com/fitelite.cz/"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link23"
            >
              <svg
                viewBox="0 0 877.7142857142857 1024"
                className="home-icon16 thq-icon-x-small"
              >
                <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
              </svg>
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61574459933009"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link24"
            >
              <svg
                viewBox="0 0 602.2582857142856 1024"
                className="home-icon18 thq-icon-x-small"
              >
                <path d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"></path>
              </svg>
            </a>
            <a
              href="https://www.youtube.com/@Fitelite_cl"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link25"
            >
              <svg
                viewBox="0 0 1024 1024"
                className="home-icon20 thq-icon-small"
              >
                <path d="M406.286 644.571l276.571-142.857-276.571-144.571v287.429zM512 152c215.429 0 358.286 10.286 358.286 10.286 20 2.286 64 2.286 102.857 43.429 0 0 31.429 30.857 40.571 101.714 10.857 82.857 10.286 165.714 10.286 165.714v77.714s0.571 82.857-10.286 165.714c-9.143 70.286-40.571 101.714-40.571 101.714-38.857 40.571-82.857 40.571-102.857 42.857 0 0-142.857 10.857-358.286 10.857v0c-266.286-2.286-348-10.286-348-10.286-22.857-4-74.286-2.857-113.143-43.429 0 0-31.429-31.429-40.571-101.714-10.857-82.857-10.286-165.714-10.286-165.714v-77.714s-0.571-82.857 10.286-165.714c9.143-70.857 40.571-101.714 40.571-101.714 38.857-41.143 82.857-41.143 102.857-43.429 0 0 142.857-10.286 358.286-10.286v0z"></path>
              </svg>
            </a>
          </div>
          <svg viewBox="0 0 1024 1024" className="home-icon22">
            <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
          </svg>
        </div>
        <div data-thq="thq-mobile-menu" className="home-mobile-menu">
          <div className="home-nav">
            <div className="home-top">
              <img
                alt="Fitness Website Logo"
                src="/thumbnail_logo%20fit%20kratke%20z-200h.webp"
                className="home-logo1"
              />
              <div data-thq="thq-close-menu" className="home-close-menu">
                <svg viewBox="0 0 1024 1024" className="home-icon24">
                  <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                </svg>
              </div>
            </div>
            <nav className="home-links2">
              <Link to="/" className="home-link110">
                Úvod
              </Link>
              <a href="#9" className="home-link26">
                Koncept
              </a>
              <a href="#pricing" className="home-link32">
                Ceník
              </a>
              <a href="#Hero91" className="home-link42">
                Otevírací doba
              </a>
              <a href="#FAQ14" className="home-link52">
                Často kladené otázky
              </a>
              <a href="#team" className="home-link62">
                Náš tým
              </a>
              <a href="#trainers" className="home-link32">
                Trenéři
              </a>
              <a href="#gallery" className="home-link72">
                Galerie
              </a>
              <a href="#Contact" className="home-link8">
                Kontaktní údaje
              </a>
            </nav>
            <a
              href="https://rezervace.fitelite.cz"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link27 thq-button-filled button"
            >
              <span className="thq-body-large home-text100">
                Přihlášení a rezervace
              </span>
            </a>
          </div>
        </div>
      </header>
      <Banner bannerId="Banner" rootClassName="bannerroot-class-name"></Banner>
      <MatterportViewer /> 
      <Hero9
        button={
          <Fragment>
            <span className="home-text101">Přihlášení a rezervace</span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text102">
              <span className="home-text103">Moderní</span>
              <span>
                {' '}
                posilovací a cardio stroje značek Matrix a Vision od firmy
                Johnson Health Tech.
              </span>
              <br></br>
              <br></br>
              <span>
                Adaptéry, kotoučová závaží a další doplňkové vybavení značek LMX
                a Crossmaxx od firmy
              </span>
              <br></br>
              <span className="home-text109">Lifemaxx</span>
              <span>.</span>
              <br></br>
              <br></br>
              <span>
                Při výběru strojů jsme brali ohled na
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text114">muže</span>
              <span className="home-text115">
                {' '}
                i
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text116">ženy</span>
              <span>
                , začátečníky i zkušené sportovce, stejně tak na ty, kteří se
                vracejí ke cvičení po pauze nebo zranění.
              </span>
              <br></br>
              <br></br>
              <span className="home-text120">Diagnostická</span>
              <span>
                {' '}
                tělesná
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text122">váha</span>
              <span>
                {' '}
                značky Tanita, která Vám dodá vhled do Vašeho zdraví pomocí
                bioelektrické impendance a inovativních technologických
                poznatků.
              </span>
              <br></br>
              <br></br>
              <span>
                3 silné klimatizační jednotky, které zajistí
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text127">komfortní</span>
              <span>
                {' '}
                teplotu jak při plné kapacitě, tak v extrémních tropických
                dnech.
              </span>
              <br></br>
              <br></br>
              <span>
                Naše fitness funguje na
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text132">čipy</span>
              <span>
                , což zajišťuje pohodlný a rychlý přístup, takže po
                zaregistrování na recepci již žádné zbytečné čekání.
              </span>
              <br></br>
              <br></br>
              <span className="home-text136">Chill zone</span>
              <span>
                {' '}
                vhodná jak pro rekonvalescenci po tréninku, tak pro relaxaci a
                odpočinek po náročném dni.
              </span>
              <br></br>
              <br></br>
              <span>
                Široká nabídka nejenom suplementů, ale i
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text141">smoothie</span>
              <span>
                , milkshakeů a dokonce mléčných proteinových produktů.
              </span>
              <br></br>
              <br></br>
              <span>
                Platit u nás můžete samozřejmě i kartou, benefitníma kartama,
                nebo depozitem.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text146">Depozit</span>
              <span>
                {' '}
                si můžete dobít pomocí platební brány a získat tak odměnu.
              </span>
              <br></br>
              <br></br>
              <span>
                Osobní lekce od našich
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text151">zkušených</span>
              <span> fitness trenérů a nutričních poradců.</span>
              <br></br>
              <br></br>
              <span>
                Na co se můžete těšit? V brzké budoucnosti u nás přibude
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text156">finská sauna</span>
              <span>
                {' '}
                a další služby, které nám umožní neustále se zlepšovat a
                poskytovat Vám lepší zážitky.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text159">Koncept</span>
          </Fragment>
        }
        rootClassName="hero9root-class-name"
      ></Hero9>
      <Pricing
        text={
          <Fragment>
            <span className="home-text160">
              Zvýhodněná měsíční permanentka pro klienty s odchodem do 13:00
              nebo příchodem po 19:00, v mezičase příplatek 50 Kč
            </span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="home-text161">
              Zvýhodněná měsíční permanentka pro klientky s odchodem do 13:00 nebo
              příchodem po 19:00, v mezičase příplatek 50 Kč
            </span>
          </Fragment>
        }
        text2={
          <Fragment>
            <span className="home-text162">
              Zvýhodněná měsíční permanentka pro klienty s odchodem do 13:00 nebo
              příchodem po 19:00, v mezičase příplatek 50 Kč
            </span>
          </Fragment>
        }
        content2={
          <Fragment>
            <span className="home-text163">
              <span>
                Díky
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text165">výhodným</span>
              <span>
                {' '}
                balíčků služeb si vybere opravdu každý.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text167">První vstup</span>
              <span>
                {' '}
                máte po registraci na recepci od nás
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Grátis</span>
              <span>
                . Akceptujeme
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text171">Multisport</span>
              <span>
                {' '}
                karty. V případě závažného úrazu po předložení lékařského
                potvrzení Vám můžeme prodloužit či pozastavit permanentku až o
                90 dnů. Více info na recepci.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text173">Studentské</span>
              <span>
                {' '}
                permanentky poskytujeme pouze na základě platného isic, nebo
                potvrzení o studiu vystavené méně než před 90 dny.
              </span>
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text175">Vyber si svůj dokonalý plán</span>
          </Fragment>
        }
        content212={
          <Fragment>
            <span className="home-text176">měsíční</span>
          </Fragment>
        }
        content213={
          <Fragment>
            <span className="home-text177">1 vstup</span>
          </Fragment>
        }
        content2123={
          <Fragment>
            <span className="home-text178">měsíční</span>
          </Fragment>
        }
        content2124={
          <Fragment>
            <span className="home-text179">měsíční</span>
          </Fragment>
        }
        content2125={
          <Fragment>
            <span className="home-text180">měsíční</span>
          </Fragment>
        }
        content2126={
          <Fragment>
            <span className="home-text181">měsíční</span>
          </Fragment>
        }
        content2127={
          <Fragment>
            <span className="home-text182">měsíční</span>
          </Fragment>
        }
        content2132={
          <Fragment>
            <span className="home-text183">1 vstup</span>
          </Fragment>
        }
        content2133={
          <Fragment>
            <span className="home-text184">1 vstup</span>
          </Fragment>
        }
        content2134={
          <Fragment>
            <span className="home-text185">1 vstup</span>
          </Fragment>
        }
        content2135={
          <Fragment>
            <span className="home-text186">1 vstup</span>
          </Fragment>
        }
        content2136={
          <Fragment>
            <span className="home-text187">1 vstup</span>
          </Fragment>
        }
        plan2Price1={
          <Fragment>
            <span className="home-text188">1 vstup</span>
          </Fragment>
        }
        plan3Price1={
          <Fragment>
            <span className="home-text189">1 vstup</span>
          </Fragment>
        }
        content21111={
          <Fragment>
            <span className="home-text190">50 vstupů</span>
          </Fragment>
        }
        content21271={
          <Fragment>
            <span className="home-text191">timelimited</span>
          </Fragment>
        }
        content21272={
          <Fragment>
            <span className="home-text192">timelimited</span>
          </Fragment>
        }
        content21273={
          <Fragment>
            <span className="home-text193">timelimited</span>
          </Fragment>
        }
        content21274={
          <Fragment>
            <span className="home-text194">timelimited</span>
          </Fragment>
        }
        content21275={
          <Fragment>
            <span className="home-text195">timelimited</span>
          </Fragment>
        }
        content21276={
          <Fragment>
            <span className="home-text196">timelimited</span>
          </Fragment>
        }
        content21277={
          <Fragment>
            <span className="home-text197">10 vstupů</span>
          </Fragment>
        }
        content21278={
          <Fragment>
            <span className="home-text198">10 vstupů</span>
          </Fragment>
        }
        content21279={
          <Fragment>
            <span className="home-text199">10 vstupů</span>
          </Fragment>
        }
        plan1Price11={
          <Fragment>
            <span className="home-text200">1 vstup</span>
          </Fragment>
        }
        plan2Action1={
          <Fragment>
            <span className="home-text201">125 Kč</span>
          </Fragment>
        }
        plan2Price12={
          <Fragment>
            <span className="home-text202">10 vstupů</span>
          </Fragment>
        }
        plan2Price13={
          <Fragment>
            <span className="home-text203">měsíční</span>
          </Fragment>
        }
        plan3Price12={
          <Fragment>
            <span className="home-text204">10 vstupů</span>
          </Fragment>
        }
        plan3Price13={
          <Fragment>
            <span className="home-text205">měsíční</span>
          </Fragment>
        }
        content211114={
          <Fragment>
            <span className="home-text206">50 vstupů</span>
          </Fragment>
        }
        content211115={
          <Fragment>
            <span className="home-text207">50 vstupů</span>
          </Fragment>
        }
        content211116={
          <Fragment>
            <span className="home-text208">50 vstupů</span>
          </Fragment>
        }
        content211117={
          <Fragment>
            <span className="home-text209">50 vstupů</span>
          </Fragment>
        }
        content211118={
          <Fragment>
            <span className="home-text210">50 vstupů</span>
          </Fragment>
        }
        content212710={
          <Fragment>
            <span className="home-text211">10 vstupů</span>
          </Fragment>
        }
        content212711={
          <Fragment>
            <span className="home-text212">10 vstupů</span>
          </Fragment>
        }
        content212712={
          <Fragment>
            <span className="home-text213">10 vstupů</span>
          </Fragment>
        }
        content212771={
          <Fragment>
            <span className="home-text214">25 vstupů</span>
          </Fragment>
        }
        content212781={
          <Fragment>
            <span className="home-text215">25 vstupů</span>
          </Fragment>
        }
        content212791={
          <Fragment>
            <span className="home-text216">25 vstupů</span>
          </Fragment>
        }
        plan1Price111={
          <Fragment>
            <span className="home-text217">Muži</span>
          </Fragment>
        }
        plan1Price113={
          <Fragment>
            <span className="home-text218">10 vstupů</span>
          </Fragment>
        }
        plan1Price114={
          <Fragment>
            <span className="home-text219">měsíční</span>
          </Fragment>
        }
        plan2Action11={
          <Fragment>
            <span className="home-text220">125 Kč</span>
          </Fragment>
        }
        plan2Action15={
          <Fragment>
            <span className="home-text221">125 Kč</span>
          </Fragment>
        }
        plan2Action17={
          <Fragment>
            <span className="home-text222">950 Kč</span>
          </Fragment>
        }
        plan2Action18={
          <Fragment>
            <span className="home-text223">990 Kč</span>
          </Fragment>
        }
        plan2Price121={
          <Fragment>
            <span className="home-text224">25 vstupů</span>
          </Fragment>
        }
        plan2Price122={
          <Fragment>
            <span className="home-text225">50 vstupů</span>
          </Fragment>
        }
        plan2Price123={
          <Fragment>
            <span className="home-text226">timelimited</span>
          </Fragment>
        }
        plan3Price121={
          <Fragment>
            <span className="home-text227">25 vstupů</span>
          </Fragment>
        }
        plan3Price122={
          <Fragment>
            <span className="home-text228">50 vstupů</span>
          </Fragment>
        }
        plan3Price123={
          <Fragment>
            <span className="home-text229">summer time</span>
          </Fragment>
        }
        rootClassName="pricingroot-class-name"
        content2127101={
          <Fragment>
            <span className="home-text230">25 vstupů</span>
          </Fragment>
        }
        content2127111={
          <Fragment>
            <span className="home-text231">25 vstupů</span>
          </Fragment>
        }
        content2127121={
          <Fragment>
            <span className="home-text232">25 vstupů</span>
          </Fragment>
        }
        plan1Price1111={
          <Fragment>
            <span className="home-text233">Ženy</span>
          </Fragment>
        }
        plan1Price1113={
          <Fragment>
            <span className="home-text234">Muži</span>
          </Fragment>
        }
        plan1Price1114={
          <Fragment>
            <span className="home-text235">Muži</span>
          </Fragment>
        }
        plan1Price1131={
          <Fragment>
            <span className="home-text236">25 vstupů</span>
          </Fragment>
        }
        plan1Price1132={
          <Fragment>
            <span className="home-text237">50 vstupů</span>
          </Fragment>
        }
        plan1Price1133={
          <Fragment>
            <span className="home-text238">timelimited</span>
          </Fragment>
        }
        plan2Action112={
          <Fragment>
            <span className="home-text239">900 Kč</span>
          </Fragment>
        }
        plan2Action113={
          <Fragment>
            <span className="home-text240">850 Kč</span>
          </Fragment>
        }
        plan2Action152={
          <Fragment>
            <span className="home-text241">1 000 Kč</span>
          </Fragment>
        }
        plan2Action153={
          <Fragment>
            <span className="home-text242">1 100 Kč</span>
          </Fragment>
        }
        plan2Action171={
          <Fragment>
            <span className="home-text243">2 250 Kč</span>
          </Fragment>
        }
        plan2Action172={
          <Fragment>
            <span className="home-text244">4 250 Kč</span>
          </Fragment>
        }
        plan2Action173={
          <Fragment>
            <span className="home-text245">790 Kč</span>
          </Fragment>
        }
        plan1Feature112={
          <Fragment>
            <span className="home-text246">
              1x preventivní měření na diagnostické váze za 50 Kč
            </span>
          </Fragment>
        }
        plan1Feature113={
          <Fragment>
            <span className="home-text247">
              1x preventivní měření na diagnostické váze za 50 Kč
            </span>
          </Fragment>
        }
        plan1Feature212={
          <Fragment>
            <span className="home-text248">platnost permanentky 3 měsíce</span>
          </Fragment>
        }
        plan1Feature213={
          <Fragment>
            <span className="home-text249">kohoutková voda zdarma</span>
          </Fragment>
        }
        plan1Price11111={
          <Fragment>
            <span className="home-text250">Studenti</span>
          </Fragment>
        }
        plan1Price11113={
          <Fragment>
            <span className="home-text251">Ženy</span>
          </Fragment>
        }
        plan1Price11114={
          <Fragment>
            <span className="home-text252">Ženy</span>
          </Fragment>
        }
        plan1Price11131={
          <Fragment>
            <span className="home-text253">Muži</span>
          </Fragment>
        }
        plan1Price11132={
          <Fragment>
            <span className="home-text254">Muži</span>
          </Fragment>
        }
        plan1Price11133={
          <Fragment>
            <span className="home-text255">Muži</span>
          </Fragment>
        }
        plan2Action1121={
          <Fragment>
            <span className="home-text256">2 125 Kč</span>
          </Fragment>
        }
        plan2Action1122={
          <Fragment>
            <span className="home-text257">4 000 Kč</span>
          </Fragment>
        }
        plan2Action1123={
          <Fragment>
            <span className="home-text258">1 300 Kč</span>
          </Fragment>
        }
        plan2Action1521={
          <Fragment>
            <span className="home-text259">2 375 Kč</span>
          </Fragment>
        }
        plan2Action1522={
          <Fragment>
            <span className="home-text260">4 500 Kč</span>
          </Fragment>
        }
        plan2Action1523={
          <Fragment>
            <span className="home-text261">850 Kč</span>
          </Fragment>
        }
        plan2Feature112={
          <Fragment>
            <span className="home-text262">
              1x preventivní měření na diagnostické váze za 50 Kč
            </span>
          </Fragment>
        }
        plan2Feature113={
          <Fragment>
            <span className="home-text263">
              1x preventivní měření na diagnostické váze za 50 Kč
            </span>
          </Fragment>
        }
        plan2Feature212={
          <Fragment>
            <span className="home-text264">platnost permanentky 3 měsíce</span>
          </Fragment>
        }
        plan2Feature213={
          <Fragment>
            <span className="home-text277">kohoutková voda zdarma</span>
          </Fragment>
        }
        plan3Feature112={
          <Fragment>
            <span className="home-text266">
              1x preventivní měření na diagnostické váze za 50 Kč
            </span>
          </Fragment>
        }
        plan3Feature113={
          <Fragment>
            <span className="home-text267">
              1x preventivní měření na diagnostické váze za 50 Kč
            </span>
          </Fragment>
        }
        plan3Feature212={
          <Fragment>
            <span className="home-text268">platnost permanentky 3 měsíce</span>
          </Fragment>
        }
        plan3Feature213={
          <Fragment>
            <span className="home-text269">kohoutková voda zdarma</span>
          </Fragment>
        }
        plan1Feature1121={
          <Fragment>
            <span className="home-text270">
              1x preventivní měření na diagnostické váze zdarma
            </span>
          </Fragment>
        }
        plan1Feature1122={
          <Fragment>
            <span className="home-text271">
              2x preventivní měření na diagnostické váze zdarma
            </span>
          </Fragment>
        }
        plan1Feature1123={
          <Fragment>
            <span className="home-text272">vyžaduje depozit 250 Kč</span>
          </Fragment>
        }
        plan1Feature1131={
          <Fragment>
            <span className="home-text273">
              pokud se vám u nás líbí, doporučujeme měsíční nebo vícevstupovou
              permanentku
            </span>
          </Fragment>
        }
        plan1Feature2121={
          <Fragment>
            <span className="home-text274">platnost permanentky 6 měsíců</span>
          </Fragment>
        }
        plan1Feature2122={
          <Fragment>
            <span className="home-text275">platnost permanentky 12 měsíců</span>
          </Fragment>
        }
        plan1Feature2123={
          <Fragment>
            <span className="home-text276">
              1x preventivní měření na diagnostické váze za 50 Kč
            </span>
          </Fragment>
        }
        plan1Feature3123={
          <Fragment>
            <span className="home-text277">kohoutková voda zdarma</span>
          </Fragment>
        }
        plan1Price111112={
          <Fragment>
            <span className="home-text278">Studenti</span>
          </Fragment>
        }
        plan1Price111113={
          <Fragment>
            <span className="home-text279">Studenti</span>
          </Fragment>
        }
        plan1Price111131={
          <Fragment>
            <span className="home-text280">Ženy</span>
          </Fragment>
        }
        plan1Price111132={
          <Fragment>
            <span className="home-text281">Ženy</span>
          </Fragment>
        }
        plan1Price111133={
          <Fragment>
            <span className="home-text282">Ženy</span>
          </Fragment>
        }
        plan2Feature1121={
          <Fragment>
            <span className="home-text283">
              1x preventivní měření na diagnostické váze zdarma
            </span>
          </Fragment>
        }
        plan2Feature1122={
          <Fragment>
            <span className="home-text284">
              2x preventivní měření na diagnostické váze zdarma
            </span>
          </Fragment>
        }
        plan2Feature1123={
          <Fragment>
            <span className="home-text285">vyžaduje depozit 200 Kč</span>
          </Fragment>
        }
        plan2Feature2121={
          <Fragment>
            <span className="home-text286">platnost permanentky 6 měsíců</span>
          </Fragment>
        }
        plan2Feature2122={
          <Fragment>
            <span className="home-text287">platnost permanentky 12 měsíců</span>
          </Fragment>
        }
        plan2Feature2123={
          <Fragment>
            <span className="home-text288">
              1x preventivní měření na diagnostické váze za 50 Kč
            </span>
          </Fragment>
        }
        plan2Feature3123={
          <Fragment>
            <span className="home-text289">kohoutková voda zdarma</span>
          </Fragment>
        }
        plan3Feature1121={
          <Fragment>
            <span className="home-text290">
              1x preventivní měření na diagnostické váze zdarma
            </span>
          </Fragment>
        }
        plan3Feature1122={
          <Fragment>
            <span className="home-text291">
              2x preventivní měření na diagnostické váze zdarma
            </span>
          </Fragment>
        }
        plan3Feature1123={
          <Fragment>
            <span className="home-text292">vyžaduje depozit 400 Kč</span>
          </Fragment>
        }
        plan3Feature2121={
          <Fragment>
            <span className="home-text293">platnost permanentky 6 měsíců</span>
          </Fragment>
        }
        plan3Feature2122={
          <Fragment>
            <span className="home-text294">platnost permanentky 12 měsíců</span>
          </Fragment>
        }
        plan3Feature2123={
          <Fragment>
            <span className="home-text295">
              1x preventivní měření na diagnostické váze za 50 Kč
            </span>
          </Fragment>
        }
        plan3Feature3123={
          <Fragment>
            <span className="home-text296">kohoutková voda zdarma</span>
          </Fragment>
        }
        plan1Feature11311={
          <Fragment>
            <span className="home-text297">
              pokud se vám u nás líbí, doporučujeme měsíční nebo vícevstupovou
              permanentku
            </span>
          </Fragment>
        }
        plan1Feature11312={
          <Fragment>
            <span className="home-text298">
              pokud se vám u nás líbí, doporučujeme měsíční nebo vícevstupovou
              permanentku
            </span>
          </Fragment>
        }
        plan1Price1111121={
          <Fragment>
            <span className="home-text299">Studenti</span>
          </Fragment>
        }
        plan1Price1111122={
          <Fragment>
            <span className="home-text300">Studenti</span>
          </Fragment>
        }
        plan1Price1111123={
          <Fragment>
            <span className="home-text301">Studenti</span>
          </Fragment>
        }
        plan3Feature11231={
          <Fragment>
            <span className="home-text302">
              platnost pouze na období od 1. 7. do 31. 8.
            </span>
          </Fragment>
        }
      ></Pricing>
      <Hero91
        text={
          <Fragment>
            <span className="home-text303">6:00 - 22:00</span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="home-text304">07:00 - 21:00</span>
          </Fragment>
        }
        heading={
          <Fragment>
            <span className="home-text305">víkendy + svátky</span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text306">Po - Pá</span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text307">Otevírací doba</span>
          </Fragment>
        }
        hero91Id="Hero91"
      ></Hero91>
      <FAQ14
        action2={
          <Fragment>
            <span className="home-text308">Napiš nám</span>
          </Fragment>
        }
        fAQ14Id="FAQ14"
        content1={
          <Fragment>
            <span className="home-text309">
              <span>
                Nevíš,
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text311">jak začít</span>
              <span>
                {' '}
                v posilovně, jak správně cvičit nebo co jíst po tréninku?
                Podívej se na časté dotazy a odpovědi!
              </span>
            </span>
          </Fragment>
        }
        content2={
          <Fragment>
            <span className="home-text313">
              Napiš nám e-mail a náš tým ti na ní odpoví!
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text314">Často kladené otázky</span>
          </Fragment>
        }
        heading2={
          <Fragment>
            <span className="home-text315">Stále máš otázku?</span>
          </Fragment>
        }
        faq1Question={
          <Fragment>
            <span className="home-text316">
              Mohu si fitness nezávazně vyzkoušet?
            </span>
          </Fragment>
        }
        faq2Question={
          <Fragment>
            <span className="home-text317">
              Je moje permanentka přenosná na jinou osobu?
            </span>
          </Fragment>
        }
        faq3Question={
          <Fragment>
            <span className="home-text318">
              Mohu permanentku zrušit nebo pozastavit?
            </span>
          </Fragment>
        }
        faq4Question={
          <Fragment>
            <span className="home-text319">
              Je možné zrušit moji rezervaci?
            </span>
          </Fragment>
        }
        faq5Question={
          <Fragment>
            <span className="home-text320">
              Mohu si donést vlastní tréninkové pomůcky?
            </span>
          </Fragment>
        }
        faq5Question1={
          <Fragment>
            <span className="home-text321">
              Jaké jsou nejvíce vytížené hodiny v gymu?
            </span>
          </Fragment>
        }
        faq5Question2={
          <Fragment>
            <span className="home-text322">
              Musím se před vstupem do fitness registrovat?
            </span>
          </Fragment>
        }
        faq5Question3={
          <Fragment>
            <span className="home-text323">
              Můžu si do fitness přinést vlastní nápoj a jídlo?
            </span>
          </Fragment>
        }
        faq5Question4={
          <Fragment>
            <span className="home-text324">
              Jsou v posilovně dostupné ručníky na půjčení?
            </span>
          </Fragment>
        }
        faq5Question5={
          <Fragment>
            <span className="home-text325">
              Co dělat, když něco zapomenu v šatně?
            </span>
          </Fragment>
        }
        faq5Question6={
          <Fragment>
            <span className="home-text326">
              Mohu si ve fitness nabít mobil?
            </span>
          </Fragment>
        }
        faq5Question7={
          <Fragment>
            <span className="home-text327">
              Jaký je minimální věk pro návštěvu fitness centra?
            </span>
          </Fragment>
        }
        faq5Question8={
          <Fragment>
            <span className="home-text328">
              Pořádáte soutěže nebo výzvy pro členy?
            </span>
          </Fragment>
        }
        faq5Question9={
          <Fragment>
            <span className="home-text329">Máte zřízený dětský koutek?</span>
          </Fragment>
        }
      ></FAQ14>
      <Team
        teamId="team"
        member1={
          <Fragment>
            <span className="home-text330">Alina</span>
          </Fragment>
        }
        member2={
          <Fragment>
            <span className="home-text331">Adéla</span>
          </Fragment>
        }
        member3={
          <Fragment>
            <span className="home-text332">Lucie</span>
          </Fragment>
        }
        content2={
          <Fragment>
            <span className="home-text333">
              <span>
                Poznej náš tým
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text335">sportovně</span>
              <span> založených recepčních.</span>
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text337">Náš tým</span>
          </Fragment>
        }
        member2Job={
          <Fragment>
            <span className="home-text338">Zdravé pečení</span>
          </Fragment>
        }
        member3Job={
          <Fragment>
            <span className="home-text339">Nutriční poradce</span>
          </Fragment>
        }
        member2Job2={
          <Fragment>
            <span className="home-text340">Osobní trenér</span>
          </Fragment>
        }
        rootClassName="teamroot-class-name"
      ></Team>
       <Trainers trainersId="trainers" />
      <Gallery
        galleryId="gallery"
        content1={
          <Fragment>
            <span className="home-text341">
              <span>
                Prohlédněte si
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text343">
                naši
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text344">galerii</span>
              <span>
                {' '}
                a nahlédněte do světa našeho
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text346">fitness centra</span>
              <span className="home-text347">!</span>
              <span>
                 Inspirujte se a
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text349">přidejte se k nám!</span>
            </span>
          </Fragment>
        }
        rootClassName="galleryroot-class-name"
      ></Gallery>
      <Contact
        email1={
          <Fragment>
            <a href="mailto:info@fitelite.cz">
            <span className="home-text350">info@fitelite.cz</span>
            </a>
          </Fragment>
        }
        phone1={
          <Fragment>
            <a href="tel:+420776403070">
            <span className="home-text351">+ 420 776 40 30 70</span>
            </a>
          </Fragment>
        }
        email11={
          <Fragment>
            <span className="home-text352">Rybná 716/24, 110 00, Praha 1</span>
          </Fragment>
        }
        address1={
          <Fragment>
            <span className="home-text353">
              Erbenova 2906, 470 01, Česká Lípa
            </span>
          </Fragment>
        }
        email111={
          <Fragment>
            <span className="home-text354">
              <span className="home-text355">IČ</span>
              <span>: 21373132</span>
            </span>
          </Fragment>
        }
        contactId="Contact"
        email1111={
          <Fragment>
            <span className="home-text357">
              <span className="home-text358">jednatel</span>
              <span>: Tomáš Kulhánek</span>
            </span>
          </Fragment>
        }
        email1112={
          <Fragment>
            <span className="home-text360">
              <span className="home-text361">DIČ</span>
              <span>: CZ21373132</span>
            </span>
          </Fragment>
        }
        heading11={
          <Fragment>
            <span className="home-text363">Kontaktní údaje</span>
          </Fragment>
        }
        rootClassName="contactroot-class-name"
      ></Contact>
      <footer className="home-footer4 thq-section-padding">
        <div className="home-max-width thq-section-max-width">
          <div className="home-content">
            <div className="home-logo2">
              <Link to="/" className="home-navlink2">
                <img
                  alt="Fit Elite Logo"
                  sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                  src="/thumbnail_logo%20fit%20dlohe%20z-1500h.webp"
                  srcSet="/thumbnail_logo%20fit%20dlohe%20z-1500h.webp 1200w, /thumbnail_logo%20fit%20dlohe%20z-tablet.webp 800w, /thumbnail_logo%20fit%20dlohe%20z-mobile.webp 480w"
                  className="home-image12"
                />
              </Link>
            </div>
            <div className="home-links3">
            <a href="https://fitelites3.s3.eu-central-1.amazonaws.com/images/gdpr.pdf" target="_blank"
    rel="noreferrer noopener" className="home-gdpr-link"><span className="home-text364" >GDPR a obchodní podmínky</span></a>
              <span
                onClick={handleOpenCookieSettings}
                className="home-gdpr-link"
                style={{ cursor: 'pointer' }}
              ><span className="home-text364" style={{ paddingRight: 0 }}>Nastavení cookies</span></span>
              <a
                href="https://www.instagram.com/fitelite.cz/"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link28"
              >
                <svg
                  viewBox="0 0 877.7142857142857 1024"
                  className="home-icon26 thq-icon-small"
                >
                  <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
                </svg>
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61574459933009"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link29"
              >
                <svg
                  viewBox="0 0 877.7142857142857 1024"
                  className="home-icon28 thq-icon-small"
                >
                  <path d="M713.143 73.143c90.857 0 164.571 73.714 164.571 164.571v548.571c0 90.857-73.714 164.571-164.571 164.571h-107.429v-340h113.714l17.143-132.571h-130.857v-84.571c0-38.286 10.286-64 65.714-64l69.714-0.571v-118.286c-12-1.714-53.714-5.143-101.714-5.143-101.143 0-170.857 61.714-170.857 174.857v97.714h-114.286v132.571h114.286v340h-304c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571z"></path>
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@Fitelite_cl"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link30"
              >
                <svg
                  viewBox="0 0 1024 1024"
                  className="home-icon30 thq-icon-small"
                >
                  <path d="M406.286 644.571l276.571-142.857-276.571-144.571v287.429zM512 152c215.429 0 358.286 10.286 358.286 10.286 20 2.286 64 2.286 102.857 43.429 0 0 31.429 30.857 40.571 101.714 10.857 82.857 10.286 165.714 10.286 165.714v77.714s0.571 82.857-10.286 165.714c-9.143 70.286-40.571 101.714-40.571 101.714-38.857 40.571-82.857 40.571-102.857 42.857 0 0-142.857 10.857-358.286 10.857v0c-266.286-2.286-348-10.286-348-10.286-22.857-4-74.286-2.857-113.143-43.429 0 0-31.429-31.429-40.571-101.714-10.857-82.857-10.286-165.714-10.286-165.714v-77.714s-0.571-82.857 10.286-165.714c9.143-70.857 40.571-101.714 40.571-101.714 38.857-41.143 82.857-41.143 102.857-43.429 0 0 142.857-10.286 358.286-10.286v0z"></path>
                </svg>
              </a>
            </div>
          </div>
          <div className="home-credits1">
            <div className="home-divider thq-divider-horizontal"></div>
            <div className="home-row1">
              <div className="home-footer-links1">
                <span className="home-content31 thq-body-small">
                  © {new Date().getFullYear()} Fit Elite s.r.o.
                </span>
              </div>
            </div>
          </div>
          <div className="home-credits2">
         <div className="home-credits2">
  <div className="home-row2">
    <div className="home-footer-links2">
      <a 
  target="_blank" 
  rel="noreferrer noopener"
  className="home-content32 thq-body-small"
  style={{ color: '#ffed01', textDecoration: 'none' }}
>
  Vytvořil s <span className="animated-heart">❤️</span> AlgoInsight team
</a>
      <span className="home-link132 thq-body-small"></span>
    </div>
  </div>
</div>
          </div>
        </div>
      </footer>

      {/* Cookie Consent Banner */}
      <CookieConsent key={cookieBannerKey} onConsent={handleCookieConsent} />
    </div>
  )
}

export default Home